module.exports = __webpack_public_path__ + "img/kefu.c5c92d26.png";